import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const GeriatricService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Arthritis management', 'Osteoporosis', 'Balance disorders and fall prevention', 'Post-hip/knee replacement', 'Mobility limitations', 'Muscle weakness', 'Chronic pain management', 'Post-stroke recovery'];
  const equipment = ['Balance training equipment', 'Walking aids training', 'Strengthening equipment', 'TENS/IFT therapy', 'Gentle exercise programs'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Geriatric / Elderly Care Physiotherapy</h1>
          <p className="service-subtitle">Specialized care for seniors to maintain independence and quality of life</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Geriatric Physiotherapy?</h2>
            <p>Geriatric physiotherapy focuses on the unique needs of older adults. We help maintain mobility, prevent falls, manage chronic conditions, and maximize independence, allowing seniors to live active, fulfilling lives.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}><CheckCircle size={20} /><span>{condition}</span></li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>We conduct comprehensive geriatric assessments including balance testing, functional mobility evaluation, and fall risk assessment. Treatment focuses on improving strength, balance, and confidence while addressing specific age-related concerns.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>Is it ever too late to start physiotherapy?</AccordionTrigger>
                <AccordionContent>It's never too late! Regardless of age, physiotherapy can help improve mobility, reduce pain, and enhance quality of life. We tailor programs to individual abilities and goals.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Can physiotherapy prevent falls in elderly?</AccordionTrigger>
                <AccordionContent>Yes, balance training and strengthening exercises significantly reduce fall risk. We also assess your home environment and provide recommendations for safety modifications.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Do you provide home visits for elderly patients?</AccordionTrigger>
                <AccordionContent>Absolutely. Home visits are often ideal for elderly patients as traveling can be challenging. Our physiotherapists bring necessary equipment to your home across Goa.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Will exercises be too difficult for seniors?</AccordionTrigger>
                <AccordionContent>All exercises are carefully tailored to your current abilities and progressed gradually. We ensure exercises are safe, effective, and achievable at any fitness level.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GeriatricService;